module.exports = __webpack_public_path__ + "img/t2-c21.f619006e.png";